import type { ComponentProps } from 'react';

import type { IRoleRequirement } from 'src/stores/JobApplicationStore/RoleRequirement';
import type { IQuestionnaireStore } from 'src/stores/JobStore/QuestionnaireStore';

import type RoleRequirement from '.';

export const mapToSimplifiedAnswers = ({
  questionnaire,
  roleRequirements,
}: {
  questionnaire: IQuestionnaireStore;
  roleRequirements: IRoleRequirement[];
}): Array<ComponentProps<typeof RoleRequirement>['roleRequirement']> =>
  roleRequirements.map((rr) => ({
    question: rr.question,
    status: rr.status,
    showVerifiedTagInAnswers: rr.showVerifiedTagInAnswers,
    answers: rr.rrAnswers.map((answer) => ({
      id: answer.globalIdOrId,
      text:
        questionnaire.getSimplifiedAnswer({
          questionId: rr.questionId,
          questionGlobalId: rr.globalId,
          answerId: answer.id,
          answerGlobalId: answer.globalId,
        }) || answer.text,
      isVerified: answer.isVerified,
    })),
    verifications: rr.verifications,
  }));
